import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "@app/shared";
import { MaterialModule } from '@app/shared/material.module';
import { CallEscalationConfigurationAddEditComponent, CallEscalationConfigurationListComponent, CallEscalationConfigurationViewComponent } from '@modules/others/configuration/components/credit-control/call-escalation-configuration';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', component: CallEscalationConfigurationListComponent, data: { title: 'Call Escalation Configuration List' }, canActivate: [AuthGuard] },
  { path: 'view', component: CallEscalationConfigurationViewComponent, data: { title: 'Call Escalation Configuration View' }, canActivate: [AuthGuard] },
  { path: 'add-edit', component: CallEscalationConfigurationAddEditComponent, data: { title: 'Call Escalation Configuration Add/Edit' }, canActivate: [AuthGuard] },
];
@NgModule({
  declarations: [CallEscalationConfigurationListComponent,CallEscalationConfigurationViewComponent,CallEscalationConfigurationAddEditComponent],
  imports: [
    CommonModule, SharedModule, MaterialModule, ReactiveFormsModule, FormsModule,
    RouterModule.forChild(routes)
  ],
  entryComponents: []
})
export class CallEscalationConfigurationModule { }
